import { Moment } from 'moment';

// outputs to the closest ex. 15 minute quarter.
// ex. input: 12:34 -> output: 12:45
export const nearestMinutes = (interval: number, someMoment: Moment) => {
  const roundedMinutes = Math.round(someMoment.clone().minute() / interval) * interval;

  return someMoment.clone().minute(roundedMinutes).second(0);
};
